import { render, staticRenderFns } from "./SelfModal.vue?vue&type=template&id=e2d535ce&scoped=true&"
import script from "./SelfModal.vue?vue&type=script&lang=js&"
export * from "./SelfModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfModal.vue?vue&type=style&index=0&id=e2d535ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d535ce",
  null
  
)

export default component.exports